var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadIcLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11461_6367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1648 3.19995C11.7227 3.19995 11.3648 3.55776 11.3648 3.99995C11.3648 4.44214 11.7227 4.79995 12.1648 4.79995C12.607 4.79995 12.9648 4.44214 12.9648 3.99995C12.9648 3.55776 12.607 3.19995 12.1648 3.19995ZM12.1648 5.59995C11.7227 5.59995 11.3648 5.95776 11.3648 6.39995C11.3648 6.84214 11.7227 7.19995 12.1648 7.19995C12.607 7.19995 12.9648 6.84214 12.9648 6.39995C12.9648 5.95776 12.607 5.59995 12.1648 5.59995ZM12.0773 7.98745C11.6648 8.03276 11.3555 8.38589 11.3648 8.79995V15.675L9.92734 14.2375C9.77734 14.0796 9.56953 13.989 9.35234 13.9875C9.02734 13.9906 8.73672 14.189 8.61641 14.4906C8.49453 14.7921 8.56953 15.1359 8.80234 15.3625L11.5023 18.05C11.5133 18.0718 11.5258 18.0921 11.5398 18.1125L11.6023 18.1625C11.7727 18.3343 12.0102 18.4187 12.2508 18.3953C12.4914 18.3703 12.707 18.239 12.8398 18.0375L15.5273 15.3625C15.7664 15.1703 15.8742 14.8593 15.8055 14.5609C15.7367 14.2609 15.5039 14.0281 15.2039 13.9593C14.9055 13.8906 14.5945 13.9984 14.4023 14.2375L12.9648 15.675V8.79995C12.968 8.58276 12.8836 8.37495 12.7305 8.22183C12.5773 8.0687 12.3695 7.98433 12.1523 7.98745C12.1273 7.98589 12.1023 7.98589 12.0773 7.98745ZM2.96484 15.2V19.9625C2.96484 20.6359 3.52891 21.2 4.20234 21.2H20.1273C20.8008 21.2 21.3648 20.6359 21.3648 19.9625V15.2H19.7648V19.6H4.56484V15.2H2.96484Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11461_6367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2.16406 2)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcLight);
export default __webpack_public_path__ + "static/media/download-icLight.56aea4b1fb98ecc8617844bb35c1aa80.svg";
export { ForwardRef as ReactComponent };